import { MobileWebviewCommunicationActions, isTwoWayCommunicationAction } from '@colonist/mobile';
import { socket, uiGameManager } from '../../../shared/scripts/EntryShared.ts';
import { uiManager } from '../EntryMobile.ts';
import { CA } from '../../../shared/scripts/analytics/Analytics.ts';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { TurnState } from '@colonist/game-states';
import { UIMDeviceHandler } from '../ui_html/UIMDeviceHandler.ts';
import { StorageWrapper } from '../../../shared/scripts/StorageWrapper.ts';
// Jan 31, 2023. Mau. This is the key that the mobile app uses to send messages to the webview. We cannot change this key.
const REACT_NATIVE_WEBVIEW_EVENT_KEY = 'message';
export class UIMMobileWebviewCommunication {
    static sendPayloadToMobile(event, data) {
        var _window_ReactNativeWebView, _window;
        if (typeof ((_window = window) === null || _window === void 0 ? void 0 : (_window_ReactNativeWebView = _window.ReactNativeWebView) === null || _window_ReactNativeWebView === void 0 ? void 0 : _window_ReactNativeWebView.postMessage) == 'function') {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                event: event,
                data: data !== null && data !== void 0 ? data : 'default'
            }));
        }
    }
    static mobileMessageHandler(event, payload) {
        switch(event){
            case MobileWebviewCommunicationActions.AppBackground:
                uiManager.mainpageController.bodyController.lobbyController.hide();
                uiGameManager === null || uiGameManager === void 0 ? void 0 : uiGameManager.gameStore.getState().gameClientConfig.setIsAppInBackground(true);
                break;
            case MobileWebviewCommunicationActions.Resize:
                if (uiGameManager == undefined) return;
                uiGameManager.canvasController.responsiveController.resizeScreen();
                uiGameManager.resizeUIGame();
                setTimeout(()=>{
                    uiGameManager.canvasController.responsiveController.resizeScreen();
                    uiGameManager.resizeUIGame();
                }, 500);
                break;
            case MobileWebviewCommunicationActions.AppForeground:
                var _uiGameManager_gameController_currentState, _uiGameManager_gameController;
                uiManager.mainpageController.bodyController.lobbyController.show();
                const isUserInGameEndScreen = (uiGameManager === null || uiGameManager === void 0 ? void 0 : (_uiGameManager_gameController = uiGameManager.gameController) === null || _uiGameManager_gameController === void 0 ? void 0 : (_uiGameManager_gameController_currentState = _uiGameManager_gameController.currentState) === null || _uiGameManager_gameController_currentState === void 0 ? void 0 : _uiGameManager_gameController_currentState.turnState) == TurnState.GameEnd;
                if (isUserInGameEndScreen) window.location.hash = '';
                socket === null || socket === void 0 ? void 0 : socket.controller.sender.sendNoop() // check connection is alive
                ;
                uiGameManager === null || uiGameManager === void 0 ? void 0 : uiGameManager.gameStore.getState().gameClientConfig.setIsAppInBackground(false);
                clearTimeout(this.trackingTimeout);
                this.trackingTimeout = setTimeout(()=>{
                    if (socket === null || socket === void 0 ? void 0 : socket.controller.isSocketOpen()) return;
                    const userStillDisconnected = {
                        type: AnalyticEventType.MobileGameUserLeftGame,
                        category: AnalyticEventCategory.MobileAnalytics,
                        stringValue: 'disconnect-foreground'
                    };
                    void CA.sendAnalyticEventsWithMobileDimensions(userStillDisconnected);
                }, 5000);
                break;
            case MobileWebviewCommunicationActions.AppEncounteredError:
                uiManager.loginController.removeLoading();
                break;
            case MobileWebviewCommunicationActions.LocalizedPricingSubscriptions:
                if (payload == undefined) return;
                StorageWrapper.setLocalizedStoreSubscriptionData(payload);
                break;
            case MobileWebviewCommunicationActions.LocalizedPricingProducts:
                if (payload == undefined) return;
                StorageWrapper.setLocalizedStoreProductData(payload);
                break;
            case MobileWebviewCommunicationActions.IAPCompleted:
                document.querySelectorAll('.store_button, .store-button-membership').forEach((el)=>el.classList.remove('loading'));
                break;
            default:
                break;
        }
    }
    constructor(){
        document.addEventListener(REACT_NATIVE_WEBVIEW_EVENT_KEY, (event)=>{
            const message = event.data;
            var _message_event;
            const eventName = (_message_event = message === null || message === void 0 ? void 0 : message.event) !== null && _message_event !== void 0 ? _message_event : message;
            var _message_payload;
            const payload = (_message_payload = message === null || message === void 0 ? void 0 : message.payload) !== null && _message_payload !== void 0 ? _message_payload : '';
            if (!isTwoWayCommunicationAction(eventName)) return;
            UIMMobileWebviewCommunication.mobileMessageHandler(eventName, payload);
        });
        UIMDeviceHandler.sendEventsOnAppLoad();
    }
}
